// Basic
import PropTypes from 'prop-types';
// Lib
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Lang
import { nsSession } from '@/app/i18n/namespaces';
import FooterConfirmation from '@/common-utils/components/renders/modal/components/footers/FooterConfirmation/FooterConfirmation';
import ICONS from '@/common-utils/enums/icons';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';
import { Trans, useTranslation } from 'react-i18next';

/**
 * @param {boolean} isOpen
 * @param {function} setIsOpen
 * @param {object} mfaDeactivationConfirmation
 * @param {boolean} mfaDeactivationResponse
 *@returns {JSX} ModalReloadPage
 */
function ModalReloadPage({ isOpen, setIsOpen }) {

    const { t } = useTranslation(nsSession);

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className={cn('max-w-xl', 'modal-secure-access')}>
                <HeaderTitle namespace={nsSession} title='modal.reload_page.title' />
                <ModalBody className='space-y-2'>
                    <div><Entity namespace={nsSession} entity='modal.reload_page.text' /></div>
                    <div><Trans i18nKey='modal.reload_page.text2' t={t} components={{ 1: <strong /> }} /></div>
                    <div><Trans i18nKey='modal.reload_page.text3' t={t} components={{ 1: <strong /> }} /></div>
                </ModalBody>
                <FooterConfirmation
                    onValidation={() => { window.location.reload(); }}
                    entityClose='button.close'
                    entityValidate={getTranslatedText('modal.reload_page.auto_refresh', nsSession)}
                    iconClose={ICONS.MIGRATE}
                    iconValidate={ICONS.AUTO_REFRESH} />
            </ModalContent>
        </Modal>
    );
}

ModalReloadPage.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    mfaDeactivationResponse: PropTypes.shape({
        isLoading: PropTypes.bool,
        responseEntity: PropTypes.string
    })
};

export default ModalReloadPage;